import React from 'react';
import classes from './LegalPageLayout.module.scss';

interface ILegalPageLayoutProps {
  title: string;
  updatedOn: string;
  children: React.ReactNode;
}

function LegalPageLayout({ title, updatedOn, children }: ILegalPageLayoutProps) {
  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <h1 className={classes.title}>{title}</h1>
        <p className={classes.updated}>Last updated: {updatedOn}</p>
        <div className={classes.content}>{children}</div>
      </div>
    </div>
  );
}

export default LegalPageLayout;
